import { createFileRoute } from "@tanstack/react-router";
import { CreateContainerShell, CreateWorkspaceProfilePage } from "@/features/workspaces";

function CreateWorkspaceProfileRoute() {
  return (
    <CreateContainerShell step={2} totalSteps={2} title="Tell us about yourself">
      <CreateWorkspaceProfilePage />
    </CreateContainerShell>
  );
}

export const Route = createFileRoute("/_authenticated/workspaces/$slug/create/profile")({
  component: CreateWorkspaceProfileRoute,
});
